import VueAnalytics from "vue-analytics";
import router from "@/router";

export default {
    install(app) {
        if (
            process.env.NODE_ENV === "production" &&
            process.env.VUE_APP_SERVER === "live" &&
            process.env.VUE_APP_GA_ID
        ) {
            app.use(VueAnalytics, {
                id: process.env.VUE_APP_GA_ID,
                // Automatically track vue-router navigation
                router,
                autoTracking: {
                    // Do not track querystring part of a url
                    transformQueryString: false,
                    // Send the actual route when navigating to 404 pages
                    prependBase: false,
                    // Do not track when navigating to the same route as the previous route
                    // Eg. /orderconfirmed/
                    skipSamePath: true
                },
                debug: {
                    // Do not track in non-production environments
                    sendHitTask: process.env.NODE_ENV === "production"
                }
                // TODO: Implement opt out if needed
                // See https://matteogabriele.gitbooks.io/vue-analytics/content/docs/opt-out.html
            });
        }
    }
};
